import React, { useState, useEffect, useRef } from "react";
import { Model, surveyLocalization, FunctionFactory } from "survey-core";
import * as SurveyCore from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.css";
import Modal from "react-modal";
import axios from "axios";
import showdown from "showdown";
import "../modal.scss";
import Loading from "./Loading/Loading";
import { inputmask } from "surveyjs-widgets";
import ReCAPTCHA from "react-google-recaptcha";
import ReactDOM from "react-dom";

inputmask(SurveyCore);
Modal.setAppElement("#root");
const AppConfig = require("application-settings");
function Content() {
  const INFO_URL = `${AppConfig.BaseUrl}/Applicant/getopenedDates`;
  const [sending, setSending] = useState();
  const [hasError, setHasError] = useState();
  const [success, setSuccess] = useState();
  const [model, setModel] = useState(undefined);
  const [questions, setQuestions] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [openedStartDay, setOpenedStartDay] = useState();
  const [openedEndDay, setOpenedEndDay] = useState();
  const [graduationDateRange, setGraduationDateRange] = useState();
  const invalidFileRef = useRef(false);
  const [lastReportDateBeginningDate, setLastReportDateBeginningDate] =
    useState();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [fileValidating, setFileValidating] = useState(false);
  const validateFileOnBackend = async (file) => {
    try {
      setFileValidating(true);
      const base64 = await toBase64(file);
      const response = await axios.post(
        `${AppConfig.BaseUrl}/applicant/validate-pdf`,
        {
          content: base64,
          name: file.name,
          type: file.type,
        }
      );

      const isValid = response.data.valid;
      if (!isValid) {
        invalidFileRef.current = true;
      }
      setFileValidating(false);
      return isValid;
    } catch {
      invalidFileRef.current = true;
      setFileValidating(false);
      return false;
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const [captchaExpired, setCaptchaExpired] = useState(false);
  const recaptchaRef = useRef();
  var temporaryFilesStorage = [];
  var sumFiles = 0;
  var converter = new showdown.Converter();
  var isFile = false;
  var fileType = false;
  var whiteListFileType = ["application/pdf"];
  const handleCaptchaVerify = (token) => {
    if (token) {
      setCaptchaVerified(true);
      updateFileButtonState(true);
    }
    setCaptchaExpired(false);
    if (model) {
      model.setVariable("captchaVerified", true);
      model.getQuestionByName("uploadFiles").visible = true;
      model.setValue("captchaVerified", !!token);
      model.refresh();
    }
    const fileInput = document.querySelector("input[type='file']");
    if (fileInput) {
      fileInput.removeAttribute("disabled");
    }
    const fileLabel = document.querySelector(
      ".sd-file__choose-btn.sd-action--disabled"
    );
    if (fileLabel) {
      fileLabel.classList.replace("sd-action--disabled", "sd-action");
    }
  };

  const handleCaptchaExpire = () => {
    if (model) {
      model.setVariable("captchaVerified", false);
      model.getQuestionByName("uploadFiles").visible = true;
    }
    updateFileButtonState(false);

    setCaptchaVerified(false);
    setCaptchaExpired(true);
    toggleModal("CAPTCHA süresi doldu, lütfen tekrar doğrulama yapın.");
  };
  const updateFileButtonState = (enabled) => {
    setTimeout(() => {
      const fileLabel = document.querySelector(".sd-file__choose-btn");
      if (fileLabel) {
        if (enabled) {
          fileLabel.classList.remove("sd-action--disabled");
          fileLabel.classList.add("sd-action");
        } else {
          fileLabel.classList.remove("sd-action");
          fileLabel.classList.add("sd-action--disabled");
        }
      }
    }, 100);
  };
  useEffect(() => {
    updateFileButtonState(false);
  }, []);
  function toggleModal(message) {
    if (message) {
      setModalMessage(message);
    } else if (sumFiles > 4) {
      setModalMessage("En fazla 4 dosya eklenebilir!");
    } else {
      if (isFile === true) {
        setModalMessage(
          "Aynı ad ve uzantıya sahip birden fazla dosya eklenemez!"
        );
      } else if (fileType === true) {
        setModalMessage(
          "Yüklemeye çalıştığınız dosyanın uzantısı izin verilenler arasında değildir. " +
            "İzin verilen dosya uzantısı: pdf"
        );
      } else {
        setModalMessage("En fazla 4 dosya eklenebilir!");
      }
    }
    setIsOpen(!isOpen);
  }

  useEffect(() => {
    if (captchaVerified) {
      const fileInput = document.querySelector("input[type='file']");
      if (fileInput) {
        fileInput.removeAttribute("disabled");
      }

      const fileLabel = document.querySelector(
        ".sd-file__choose-btn.sd-action--disabled"
      );
      if (fileLabel) {
        fileLabel.classList.remove("sd-action--disabled");
      }
    }
  }, [captchaVerified]);

  useEffect(() => {
    getDynamicParameters();
    window.scrollTo(0, 0);
  }, []);
  // Client Get Datas
  const graduationDateRangeFinder = () => {
    const currentYear = new Date().getFullYear();
    const choices = [];
    for (let i = currentYear; i <= currentYear + 10; i++) {
      choices.push(i.toString());
    }
    setGraduationDateRange(choices);
  };
  useEffect(() => {
    if (graduationDateRange) {
      getJsonData();
    }
  }, [graduationDateRange]);
  const getDynamicParameters = async () => {
    const response = await axios.get(INFO_URL);
    const tmpdata = response?.data[0];
    setOpenedStartDay(tmpdata.OpenedStartDate);
    setOpenedEndDay(tmpdata.OpenedEndDate);

    minLastReportDateFinder();
    graduationDateRangeFinder();
  };

  const minLastReportDateFinder = () => {
    const today = new Date();
    const threeWeeksLater = new Date(
      today.getTime() + 3 * 7 * 24 * 60 * 60 * 1000
    );
    const dayOfWeek = threeWeeksLater.getDay();
    const daysUntilNextFriday = (5 - dayOfWeek + 7) % 7;
    const nextFriday = new Date(
      threeWeeksLater.getTime() + daysUntilNextFriday * 24 * 60 * 60 * 1000
    );
    const year = nextFriday.getFullYear();
    const month = String(nextFriday.getMonth() + 1).padStart(2, "0");
    const day = String(nextFriday.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    setLastReportDateBeginningDate(formattedDate);
  };

  const getJsonData = async () => {
    const pathName = window.location.pathname;
    let questionFile = "";
    if (pathName === "/automation") {
      questionFile = "./automationquestions.json";
    } else if (pathName === "/bilgiislem") {
      questionFile = "./itquestions.json";
    } else if (pathName === "/teknisyen") {
      questionFile = "./technicianquestions.json";
    } else if (pathName === "/internship") {
      questionFile = "./internshipquestions.json";
    } else {
      questionFile = "./internshipquestions.json";
    }
    await axios.get(questionFile).then((res) => {
      const question = res.data.questions;
      question.forEach((q) => {
        if (q.type === "html" && q.name === "welcome") {
          q.html = <p>${AppConfig.FormHeader}</p>;
        }
        if (graduationDateRange) {
          if (q.elements) {
            if (
              q.elements[1].choices ===
              "calculatedDatesForExpectedGraduationDate"
            ) {
              q.elements[1].choices = graduationDateRange;
            }
          }
          if (q.max === "getOpenedEndDay") {
            const formattedOpenedEndDay =
              formatDateForOpenedDates(openedEndDay);
            q.max = formattedOpenedEndDay;
          }
          if (q.min === "getOpenedStartDay") {
            const formattedOpenedStartDay =
              formatDateForOpenedDates(openedStartDay);
            q.min = formattedOpenedStartDay;
          }
          if (q.min === "getLastReportDateBeginningDate") {
            q.min = lastReportDateBeginningDate;
          }
        }
      });
      const model = new Model({ questions: question });
      model.setVariable("captchaVerified", false);
      if (!sending && !success && model) {
        model.onValueChanged.add(function (survey, options) {
          if (options.name === "reference") {
            const referenceMatrix = survey.getQuestionByName("reference");

            referenceMatrix.visibleRows.forEach((row) => {
              const positionValue = row.getValue("reference_position");
              const contactValue = row.getValue("reference_contact");
              const referenceName = row.getValue("reference_name");

              // Eğer position veya contact alanları doluysa, name alanını zorunlu yap
              if (positionValue || contactValue) {
                row.getQuestionByColumnName("reference_name").isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_name"
                ).isRequired = false;
              }
              if (referenceName) {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = false;
              }
            });
          }
        });
        model.onAfterRenderQuestion.add(function (survey, options) {
          if (
            options.question.name === "fullname" ||
            options.question.name === "schoolDepartment" ||
            options.question.name === "workingAcquaintanceComment"
          ) {
            const input = options.htmlElement.querySelector("input");

            input.onkeypress = function (event) {
              const char = String.fromCharCode(event.which);
              if (!/^[A-Za-zğüşöçİĞÜŞÖÇı ]+$/.test(char)) {
                event.preventDefault();
              }
            };
          }
          if (options.question.name === "schoolGrade") {
            const input = options.htmlElement.querySelector("input");
            input.onkeydown = function (event) {
              const char = event.key;
              if (
                char === "-" ||
                (!/^\d$/.test(char) &&
                  char !== "." &&
                  char !== "," &&
                  char !== "Backspace" &&
                  char !== "ArrowLeft" &&
                  char !== "ArrowRight")
              ) {
                event.preventDefault();
              }
              if (
                (char === "." || char === ",") &&
                (input.value.includes(".") || input.value.includes(","))
              ) {
                event.preventDefault();
              }
            };
            input.oninput = function () {
              const value = parseFloat(input.value.replace(",", ".")); // Virgülü nokta olarak değerlendir
              if (value < 0 || value > 4) {
                input.value = "";
              }
            };
          }
          if (options.question.name === "lastReportDate") {
            const input = options.htmlElement.querySelector("input");
            const today = new Date().toISOString().split("T")[0];

            input.setAttribute("min", today);
          }

          if (
            options.question.name === "uploadFiles" ||
            options.question.getType() === "file"
          ) {
            const container = document.createElement("div");
            container.style.display = "flex";
            container.style.alignItems = "center";
            container.style.gap = "10px";
            container.style.backgroundColor = "white";
            container.style.marginBottom = "20px";
            options.htmlElement.appendChild(container);

            const captchaContainer = document.createElement("div");
            captchaContainer.id = "captcha-container";
            container.appendChild(captchaContainer);

            const captcha = (
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={AppConfig.SiteKey}
                size="compact"
                onChange={handleCaptchaVerify}
                onExpired={handleCaptchaExpire}
              />
            );
            ReactDOM.render(captcha, captchaContainer);
            const captchaInfoContainer = document.createElement("div");
            captchaInfoContainer.style.marginTop = "5px";
            captchaInfoContainer.style.fontSize = "12px";
            captchaInfoContainer.style.color = "#666";
            captchaInfoContainer.textContent =
              "Lütfen dosya yüklemeden önce CAPTCHA doğrulayınız.";
            container.appendChild(captchaInfoContainer);
          }
        });
      }
      setModel(model);
      setQuestions(question);
    });
  };
  const formatDate = (dateString) => {
    const day = dateString.slice(-2);
    const month = dateString.slice(4, 6);
    const year = dateString.slice(0, 4);

    return `${year}-${month}-${day}`;
  };

  const formatDateForOpenedDates = (dateString) => {
    const day = dateString.slice(8, 10);
    const month = dateString.slice(5, 7);
    const year = dateString.slice(0, 4);

    return `${year}-${month}-${day}`;
  };
  const axiosPost = async (answers) => {
    const pathName = window.location.pathname;
    let applicantType = "";
    if (pathName === "/automation") {
      applicantType = "automation";
    } else if (pathName === "/bilgiislem") {
      applicantType = "it";
    } else if (pathName === "/teknisyen") {
      applicantType = "technician";
    } else if (pathName === "/internship") {
      applicantType = "internship";
    } else {
      applicantType = "internship";
    }
    try {
      setSuccess(false);
      let data = { ...answers };
      data.lastReportDate = formatDate(data.lastReportDate);
      await axios
        .post(`${AppConfig.BaseUrl}/applicant/applicant-information`, {
          answers: data,
          applicantType,
        })
        .then((response) => {
          const conflictDate = response.data;
          if (conflictDate.length > 0) {
            alert(`Bu tarihler arasında: ${JSON.stringify(conflictDate)}`);
          } else {
            setSuccess(true);
          }
        });
      setSending(false);
    } catch (error) {
      setHasError(true);
      setSuccess(false);
      setSending(false);
      const errorMessage =
        error.response?.data?.message || "Bilinmeyen bir hata oluştu.";
      toggleModal(errorMessage);
      const model = new Model({ questions: questions });
      model.data = answers;
      if (!sending && !success && model) {
        model.onValueChanged.add(function (survey, options) {
          if (options.name === "reference") {
            const referenceMatrix = survey.getQuestionByName("reference");

            referenceMatrix.visibleRows.forEach((row) => {
              const positionValue = row.getValue("reference_position");
              const contactValue = row.getValue("reference_contact");
              const referenceName = row.getValue("reference_name");

              if (positionValue || contactValue) {
                row.getQuestionByColumnName("reference_name").isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_name"
                ).isRequired = false;
              }
              if (referenceName) {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = false;
              }
            });
          }
        });
        model.onAfterRenderQuestion.add(function (survey, options) {
          if (
            options.question.name === "fullname" ||
            options.question.name === "schoolDepartment" ||
            options.question.name === "workingAcquaintanceComment"
          ) {
            const input = options.htmlElement.querySelector("input");
            input.onkeypress = function (event) {
              const char = String.fromCharCode(event.which);
              if (!/^[A-Za-zğüşöçİĞÜŞÖÇı ]+$/.test(char)) {
                event.preventDefault();
              }
            };
          }
          if (options.question.name === "schoolGrade") {
            const input = options.htmlElement.querySelector("input");
            input.onkeydown = function (event) {
              const char = event.key;
              if (
                char === "-" ||
                (!/^\d$/.test(char) &&
                  char !== "." &&
                  char !== "," &&
                  char !== "Backspace" &&
                  char !== "ArrowLeft" &&
                  char !== "ArrowRight")
              ) {
                event.preventDefault();
              }
              if (
                (char === "." || char === ",") &&
                (input.value.includes(".") || input.value.includes(","))
              ) {
                event.preventDefault();
              }
            };
            input.oninput = function () {
              const value = parseFloat(input.value.replace(",", "."));
              if (value < 0 || value > 4) {
                input.value = "";
              }
            };
          }
          if (options.question.name === "lastReportDate") {
            const input = options.htmlElement.querySelector("input");
            const today = new Date().toISOString().split("T")[0];
            input.setAttribute("min", today);
          }
        });
      }
      setModel(model);
      return;
    }
  };

  surveyLocalization.locales["en"].chooseFileCaption = "Dosya seçin";
  surveyLocalization.locales["en"].noFileChosen = "Seçili dosya yok";
  surveyLocalization.locales["en"].cleanCaption = "Tümünü sil";
  surveyLocalization.locales["en"].removeFileCaption = "Bu dosyayi sil";
  surveyLocalization.locales["en"].exceedMaxSize =
    "Eklenecek her bir dosyanın boyutu en fazla {0} olabilir!";
  surveyLocalization.locales["en"].fileDragAreaPlaceholder =
    "Dosyaları yüklemek için dosyalarınızı sürükleyin veya yüklemek için aşağıdaki butona tıklayın.";

  function addDaysForEndDate([
    startDate,
    duration,
    durationForVolunteer,
    status,
  ]) {
    if (!startDate) return;
    const result = new Date(startDate);
    if (
      status === "Zorunlu" &&
      duration != null &&
      durationForVolunteer != null
    ) {
      //zorunlu staj yapan
      result.setDate(result.getDate() + duration * 7);
      return result;
    } else if (
      status === "İsteğe bağlı" &&
      duration != null &&
      durationForVolunteer != null
    ) {
      //isteğe bağlı staj yapan
      result.setDate(result.getDate() + durationForVolunteer * 7);
      return result;
    } else if (status === "Zorunlu" && durationForVolunteer == null) {
      //zorunlu staj yapan
      result.setDate(result.getDate() + duration * 7);
      return result;
    } else if (status === "İsteğe bağlı" && duration == null) {
      //isteğe bağlı staj yapan
      result.setDate(result.getDate() + durationForVolunteer * 7);
      return result;
    }
  }

  function addDaysForStartDate([lastReportDate]) {
    if (!lastReportDate) return;
    if (lastReportDate <= openedStartDay) {
      return openedStartDay;
    }
    if (lastReportDate > openedStartDay) {
      return lastReportDate;
    }
  }

  FunctionFactory.Instance.register("addDaysForEndDate", addDaysForEndDate);
  FunctionFactory.Instance.register("addDaysForStartDate", addDaysForStartDate);

  return (
    <div className="customContent">
      {sending && <Loading />}
      {fileValidating && (
        <div className="validation-loading">
          <Loading text="Dosya doğrulanıyor..." />
        </div>
      )}
      {hasError && (
        <div className="errorSendForm">
          Bir hata oluştu formu doldurup tekrardan gönderiniz.
        </div>
      )}
      {success && (
        <div className="successSendForm">Form başarıyla gönderildi.</div>
      )}
      {captchaExpired && (
        <div style={{ marginTop: "10px", fontSize: "14px", color: "red" }}>
          CAPTCHA süresi doldu, lütfen tekrar doğrulama yapın.
        </div>
      )}
      {!sending && !success && model && (
        <Survey
          onClearFiles={(sender, options) => {
            if (temporaryFilesStorage[options.name] === undefined) {
              temporaryFilesStorage[options.name] = options.value;
            }
            var tempFiles = temporaryFilesStorage[options.name];
            var removeFile = 0;
            var fileInfoToRemove = tempFiles.filter(function (file) {
              if (options.fileName == null) {
                removeFile = options.value.length;
              } else {
                removeFile = 1;
              }
              return file.name === options.fileName;
            })[0];
            if (fileInfoToRemove !== undefined) {
              var index = tempFiles.indexOf(fileInfoToRemove);
              tempFiles.splice(index, 1);
            }
            options.callback("success");
            sumFiles = sumFiles - removeFile;
            if (sumFiles < 0) {
              sumFiles = 0;
            }
          }}
          onUploadFiles={(sender, options) => {
            invalidFileRef.current = false;
            if (!captchaVerified) {
              toggleModal(
                "Dosya yüklemek için CAPTCHA doğrulaması yapmalısınız."
              );
              fileType = false;
              return;
            }
            isFile = false;
            if (options.question.previewValue.length > 0) {
              sumFiles = options.question.previewValue.length;
              let breakException = {};
              try {
                options.question.previewValue.forEach(function (file1) {
                  options.files.forEach(function (file2) {
                    if (file1.name === file2.name) {
                      isFile = true;
                      throw breakException;
                    } else {
                      isFile = false;
                    }
                  });
                });
              } catch (e) {
                if (e !== breakException) throw e;
              }
            }

            let breakException = {};
            var isType = 0;
            try {
              options.files.forEach(function (file) {
                whiteListFileType.forEach(function (type) {
                  if (file.type === type) {
                    isType++;
                  }
                });
              });
              if (isType === 0) {
                fileType = true;
                throw breakException;
              }
            } catch (e) {
              if (e !== breakException) throw e;
            }
            sumFiles = sumFiles + options.files.length;
            if (sumFiles <= 4 && isFile === false && fileType === false) {
              if (temporaryFilesStorage[options.name] !== undefined) {
                temporaryFilesStorage[options.name] = temporaryFilesStorage[
                  options.name
                ].concat(options.files);
              } else {
                temporaryFilesStorage[options.name] = options.files;
              }
              var content = [];
              options.files.forEach(async function (file) {
                let fileReader = new FileReader();
                fileReader.onload = async function () {
                  const base64Content = fileReader.result;
                  const isValid = await validateFileOnBackend(file);
                  if (!isValid) {
                    sumFiles -= 1;
                    invalidFileRef.current = true;
                    toggleModal(
                      "Yüklenen dosya güvenlik kontrollerinden geçemedi. Lütfen başka bir PDF deneyin."
                    );
                    options.callback("error");
                    return;
                  }
                  content = content.concat([
                    {
                      name: file.name,
                      type: file.type,
                      content: base64Content,
                      file: file,
                    },
                  ]);
                  if (content.length === options.files.length) {
                    options.callback(
                      "success",
                      content.map(function (fileContent) {
                        return {
                          file: fileContent.file,
                          content: fileContent.content,
                        };
                      })
                    );
                  }
                };
                fileReader.readAsDataURL(file);
              });
            } else {
              sumFiles = sumFiles - options.files.length;
              toggleModal();
            }
          }}
          showCompletedPage={false}
          model={model}
          completeText="Formu Gönder"
          onComplete={async (result) => {
            if (invalidFileRef.current) {
              toggleModal("Geçersiz bir dosya yüklendi. Form gönderilemez.");
              return;
            }
            setHasError(false);
            setSending(true);
            const jsonString = JSON.stringify(result.data).replaceAll("-", "");
            const jsonData = JSON.parse(jsonString);
            await axiosPost(jsonData);
          }}
          onTextMarkdown={(survey, options) => {
            var str = converter.makeHtml(options.text);
            str = str.substring(3);
            str = str.substring(0, str.length - 4);
            options.html = str;
          }}
        />
      )}
      <Modal
        isOpen={isOpen}
        onRequestClose={() => toggleModal()}
        contentLabel="My dialog"
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={0}
        shouldCloseOnOverlayClick={false}
      >
        <div>{modalMessage}</div>
        <br />
        <button
          onClick={(e) => {
            e.preventDefault();
            toggleModal();
          }}
        >
          Kapat
        </button>
      </Modal>
    </div>
  );
}

export default Content;
